import http from "@/utils/http";
export const getNoticeList = (params: any): Promise<any> => {
    return http({
        method: 'POST',
        url: 'fe-ex-api/notice/notice_info_list',
        data: params
    })
}
export const postNoticeInfo= (params: any): Promise<any> => {
    return http({
        method: 'POST',
        url: 'fe-ex-api/notice/notice_info',
        data: params
    })
}